import { render } from "./Datatable.vue?vue&type=template&id=658f1ad7"
import script from "./Datatable.vue?vue&type=script&lang=js"
export * from "./Datatable.vue?vue&type=script&lang=js"
script.render = render

export default script